import { useState } from "react";

// ───────────────────────── Internaționalizare (RO/EN) ─────────────────────────
// Același tipar ca restul suitei CentralSec (Investigații, Hub Client):
// traducere prin CĂUTAREA DIRECTĂ a textului românesc sursă, nu chei
// artificiale — orice șir netradus rămâne pur și simplu în română, deci nu
// produce niciodată chei brute vizibile pe ecran. Acoperă interfața
// aplicației (chrome-ul: login, bară de sus, taburi, etichete, butoane,
// stări document) — conținutul introdus de utilizator (titluri de
// documente, nume de clienți/situri/procese, text liber în textarea-uri,
// mesaje de eroare dinamice de la backend) rămâne netradus, exact ca la
// celelalte aplicații din suită (nu se poate traduce automat text liber
// scris de altcineva).
const LANG_STORAGE_KEY = "sop-management-lang";

function getLang() {
  try {
    return localStorage.getItem(LANG_STORAGE_KEY) === "en" ? "en" : "ro";
  } catch {
    return "ro";
  }
}

function setStoredLang(lang) {
  try {
    localStorage.setItem(LANG_STORAGE_KEY, lang === "en" ? "en" : "ro");
  } catch {
    // ignore
  }
}

export function useLang() {
  const [lang, setLangState] = useState(getLang());
  const changeLang = (l) => {
    setStoredLang(l);
    setLangState(l === "en" ? "en" : "ro");
  };
  return [lang, changeLang];
}

export const EN_STRINGS = {
  // ── Login ──
  "Standarde, Proceduri & Instrucțiuni de Securitate": "Security Standards, Procedures & Instructions",
  "Email": "Email",
  "Parolă": "Password",
  "Se conectează…": "Signing in…",
  "Conectare": "Sign in",
  "Made by": "Made by",

  // ── Topbar / tabs / roluri ──
  "Documente": "Documents",
  "Clienți & Situri": "Clients & Sites",
  "Procese": "Processes",
  "Utilizatori": "Users",
  "Securitate cont": "Account Security",
  "Notificări": "Notifications",
  "Ieșire": "Log out",
  "Owner": "Owner",
  "Editor": "Editor",
  "Aprobator": "Approver",
  "Reprezentant Client": "Client Representative",

  // ── Niveluri document (templates.js) ──
  "Politică": "Policy",
  "Standard": "Standard",
  "Procedură (SOP)": "Procedure (SOP)",
  "Instrucțiune de Lucru": "Work Instruction",

  // ── Funcții predefinite (matrice RACI) ──
  "Agent Securitate": "Security Officer",
  "Recepție Persoane": "Visitor Reception",
  "Dispecer": "Dispatcher",
  "Șef Tură Securitate": "Security Shift Leader",
  "Manager Dispecerat": "Dispatch Manager",
  "Șef Obiectiv": "Site Security Manager",
  "Manager Securitate": "Security Manager",

  // ── Câmpuri șablon POLITICA ──
  "Declarație de intenție": "Statement of intent",
  "Aplicabilitate globală": "Global applicability",
  "Responsabilități executive": "Executive responsibilities",

  // ── Câmpuri șablon STANDARD ──
  "Introducere": "Introduction",
  "Scop și aplicabilitate (ariile de operațiuni acoperite)": "Scope and applicability (areas of operation covered)",
  "Documente de referință": "Reference documents",
  "Termeni și definiții": "Terms and definitions",
  "Roluri și responsabilități (cine aprobă, cine implementează, cine verifică)":
    "Roles and responsibilities (who approves, who implements, who verifies)",
  "Sancțiuni pentru nerespectare": "Sanctions for non-compliance",

  // ── Câmpuri șablon PROCEDURA ──
  "Obiectiv (ce problemă sau proces specific reglementează)": "Objective (what specific problem or process it regulates)",
  "Descrierea procesului": "Process description",
  "Gestionarea excepțiilor": "Exception handling",
  "Cum se măsoară eficiența procedurii": "How the procedure's effectiveness is measured",
  "Responsabilități pe funcții (Matrice RACI)": "Responsibilities by function (RACI Matrix)",
  "Anexe și formulare": "Annexes and forms",

  // ── Câmpuri șablon INSTRUCTIUNE ──
  "Pași operaționali (Checklist)": "Operational steps (Checklist)",
  "Acțiuni de urgență": "Emergency actions",
  "Numere de contact post": "Post contact numbers",

  // ── Stări document ──
  "Ciornă": "Draft",
  "În Așteptare Aprobare": "Pending Approval",
  "În Așteptare Co-Validare Client": "Pending Client Co-Validation",
  "Aprobat": "Approved",
  "Respins": "Rejected",
  "Arhivat": "Archived",
  "arh.": "arch.",

  // ── shared.jsx ──
  "+ Adaugă": "+ Add",

  // ── DocumentePanel ──
  "Selectează sau creează mai întâi un client în tab-ul „Clienți & Situri”.":
    "First select or create a client in the \"Clients & Sites\" tab.",
  "Ierarhie documente": "Document hierarchy",
  "+ Politică": "+ Policy",
  "Se încarcă…": "Loading…",
  "Niciun document încă.": "No documents yet.",
  "Selectează un document din arbore, sau creează unul nou.": "Select a document from the tree, or create a new one.",
  "Editează document": "Edit document",
  "Document nou": "New document",

  // ── DocumentDetail ──
  "Se creează o copie Ciornă v1.0, cu identitatea documentului resetată (creator, aprobator, co-validare) — pregătită pentru reutilizarea know-how-ului pe un alt client/sit.":
    "Creates a v1.0 Draft copy with the document's identity reset (creator, approver, co-validation) — ready to reuse this know-how for another client/site.",
  "Client țintă": "Target client",
  "— alege —": "— choose —",
  "Situri țintă (opțional)": "Target sites (optional)",
  "Se clonează…": "Cloning…",
  "Clonează": "Clone",
  "Istoric versiuni": "Version history",
  "Versiune": "Version",
  "Stare": "Status",
  "Creator": "Creator",
  "Ce s-a schimbat": "What changed",
  "curentă": "current",
  "Motiv (obligatoriu)": "Reason (required)",
  "Confirmă respingerea": "Confirm rejection",
  "Respinge documentul": "Reject document",
  "Solicită revizii": "Request revisions",
  "Creează versiune nouă": "Create new version",
  "Documentul curent rămâne needitabil în istoric. Se creează o nouă Ciornă, pornind de la conținutul actual.":
    "The current document stays uneditable in history. A new Draft is created, starting from the current content.",
  "Ce s-a schimbat față de versiunea anterioară (obligatoriu)": "What changed compared to the previous version (required)",
  "Creează versiunea nouă": "Create new version",
  "Versiunea": "Version",
  "Creat de": "Created by",
  "Aprobat de": "Approved by",
  "Data intrării în vigoare": "Effective date",
  "Termen de revizuire": "Review due date",
  "Data aprobării": "Approval date",
  "Acest document este proprietatea": "This document is the property of",
  " și conține informații confidențiale — nu poate fi distribuit în afara organizației fără acordul Policy Owner-ului. Versiunea publicată în platformă are întotdeauna prioritate față de orice copie tipărită sau exportată.":
    " and contains confidential information — it may not be distributed outside the organization without the Policy Owner's consent. The version published in the platform always takes precedence over any printed or exported copy.",
  "Co-validare client": "Client co-validation",
  "validat de": "validated by",
  "necesară, în așteptare": "required, pending",
  "Motiv respingere": "Rejection reason",
  "Situri": "Sites",
  "KPI-uri asociate": "Associated KPIs",
  "Indicator": "Indicator",
  "Țintă": "Target",
  "Frecvență": "Frequency",
  "Editează": "Edit",
  "Trimite spre aprobare": "Submit for approval",
  "Aprobă": "Approve",
  "Respinge": "Reject",
  "Validează (Co-Semnare)": "Validate (Co-Sign)",
  "+ Document copil": "+ Child document",
  "Clonează pe alt client/sit": "Clone to another client/site",
  "Arhivează": "Archive",
  "Funcție": "Function",
  "Termen": "Term",
  "Definiție": "Definition",
  "Responsabilitate": "Responsibility",

  // ── Instruire și Evaluare (SoW 3.5) ──
  "Instruire și Evaluare — funcții alocate": "Training & Assessment — assigned roles",
  "Test AI →": "AI Test →",
  "Instruire AI": "AI Training",
  "Niciun test generat încă pentru această funcție.": "No test generated yet for this role.",
  "Generează test cu AI Engine": "Generate test with AI Engine",
  "Se generează…": "Generating…",
  "Se regenerează…": "Regenerating…",
  "Regenerează": "Regenerate",
  "Generat de": "Generated by",
  "Susține testul acum": "Take the test now",
  "Istoric susțineri": "Attempt history",
  "Participant": "Participant",
  "Scor": "Score",
  "Data": "Date",
  "Numele participantului": "Participant's name",
  "Răspunde la toate întrebările înainte de a trimite.": "Answer all questions before submitting.",
  "Trimite răspunsurile": "Submit answers",
  "Rezultat": "Result",
  "Înapoi": "Back",

  // ── Anexe (DocumentDetail) ──
  "Anexe (planuri, schițe, documente scanate)": "Attachments (plans, drawings, scanned documents)",
  "Nicio anexă.": "No attachments.",
  "Fișier": "File",
  "Mărime": "Size",
  "Încărcat de": "Uploaded by",
  "Descarcă": "Download",
  "+ Adaugă anexă": "+ Add attachment",

  // ── Stocare (ClientsPanel) ──
  "Spațiu de stocare": "Storage",
  "din": "of",
  "nelimitat": "unlimited",
  "fișiere": "files",

  // ── DocumentForm ──
  "+ Adaugă rând": "+ Add row",
  "R = Responsabil, A = Aprobator, C = Consultat, I = Informat": "R = Responsible, A = Accountable, C = Consulted, I = Informed",
  "Unitate": "Unit",
  "zilnic, lunar...": "daily, monthly...",
  "✕ Elimină": "✕ Remove",
  "+ Adaugă KPI (opțional)": "+ Add KPI (optional)",
  "+ Adaugă termen": "+ Add term",
  "Rol / Funcție": "Role / Function",
  "Responsabilitate (aprobă / implementează / verifică)": "Responsibility (approves / implements / verifies)",
  "+ Adaugă rol": "+ Add role",
  "Titlu": "Title",
  "Policy Owner — nume": "Policy Owner — name",
  "Proprietarul de business al documentului (poate diferi de creator/aprobator).":
    "The document's business owner (may differ from the creator/approver).",
  "Policy Owner — funcție": "Policy Owner — role",
  "sub": "under",
  "KPI-uri asociate (opțional)": "Associated KPIs (optional)",
  "Situri aplicabile": "Applicable sites",
  "Clientul nu are situri încă.": "The client has no sites yet.",
  "Procese acoperite": "Processes covered",
  "(obligatoriu)": "(required)",
  "Opțional — dacă publicarea e programată ulterior aprobării.": "Optional — if publication is scheduled after approval.",
  "Co-validare client (Dual-Sign)": "Client co-validation (Dual-Sign)",
  "Necesită aprobarea reprezentantului clientului înainte de publicare": "Requires client representative approval before publication",
  "Se salvează…": "Saving…",
  "Salvează modificările": "Save changes",
  "Creează Ciornă": "Create Draft",
  "Anulează": "Cancel",

  // ── ClientsPanel ──
  "Client nou": "New client",
  "Sit nou": "New site",
  "Denumire": "Name",
  "Domeniu de activitate": "Field of activity",
  "Adresă": "Address",
  "Salvează": "Save",
  "Tip": "Type",
  "Fabrică, Depozit, Birou...": "Factory, Warehouse, Office...",
  "+ Client nou": "+ New client",
  "Niciun client încă.": "No clients yet.",
  "situri": "sites",
  "+ Sit": "+ Site",
  "Sit": "Site",
  "Niciun sit.": "No sites.",

  // ── ProcesePanel ──
  "Registre": "Registries",
  "Registrul de Procese": "Process Registry",
  "Procesele majore de business folosite pentru maparea obligatorie a Standardelor, Procedurilor și Instrucțiunilor.":
    "The major business processes used for the mandatory mapping of Standards, Procedures and Instructions.",
  "Denumire proces nou": "New process name",
  "Adaugă": "Add",
  "Registrul de Linii Majore de Activitate": "Major Activity Lines Registry",
  "Ariile majore de securitate derivate din obiectivele de business ale Politicii (ex. Physical Security, Travel Security) — fiecare Standard trebuie asociat exact uneia dintre ele.":
    "The major security areas derived from the Policy's business objectives (e.g. Physical Security, Travel Security) — every Standard must be linked to exactly one of them.",
  "Denumire linie majoră nouă": "New major line name",
  "Linie Majoră de Activitate": "Major Activity Line",
  "Aria de securitate acoperită de acest Standard (ex. Physical Security, Travel Security).":
    "The security area covered by this Standard (e.g. Physical Security, Travel Security).",

  // ── UsersPanel ──
  "Editor (creator conținut)": "Editor (content creator)",
  "Reprezentant Client (co-validare)": "Client Representative (co-validation)",
  "Cont nou": "New account",
  "Nume complet": "Full name",
  "Manager Securitate Regional": "Regional Security Manager",
  "Rol": "Role",
  "Client": "Client",
  "Contul va fi scopat strict la acest client.": "The account will be scoped strictly to this client.",
  "Creează cont": "Create account",
  "Editează —": "Edit —",
  "+ Cont nou": "+ New account",
  "Nume": "Name",
  "Activ": "Active",
  "Dezactivat": "Disabled",
  "Dezactivează": "Deactivate",
  "Activează": "Activate",
};

export function t(lang, roText) {
  if (lang !== "en") return roText;
  return EN_STRINGS[roText] || roText;
}

export function statusLabel(status, lang, STATUS_LABEL) {
  return t(lang, STATUS_LABEL[status] || status);
}

export function levelLabel(level, lang, LEVEL_LABEL) {
  return t(lang, LEVEL_LABEL[level] || level);
}

export function roleLabel(role, lang, ROLE_LABEL) {
  return t(lang, ROLE_LABEL[role] || role);
}

// Comutator RO/EN — aceeași pereche (lang, onLangChange) e ridicată o
// singură dată în App() (persistă în localStorage), ca ecranul de login
// și restul aplicației să rămână mereu în aceeași limbă, inclusiv peste
// logout. Text simplu, fără iconițe — butonul activ colorat turcoaz,
// inactiv atenuat (fundal întunecat, folosit atât în topbar cât și pe
// ecranul de login).
export function LangSwitch({ lang, onChange }) {
  return (
    <div className="lang-switch">
      <button type="button" onClick={() => onChange("ro")} className={lang === "ro" ? "active" : ""}>RO</button>
      <span>/</span>
      <button type="button" onClick={() => onChange("en")} className={lang === "en" ? "active" : ""}>EN</button>
    </div>
  );
}

// Iconițe inline (aceleași contururi Lucide folosite în restul suitei
// CentralSec/Hub Client — Bell, Key, LogOut), fără dependență nouă de pachet.
export function LogOutIcon({ size = 14, className }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  );
}

export function BellIcon({ size = 14, className }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  );
}

export function KeyIcon({ size = 14, className }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" />
    </svg>
  );
}

// Badge "Made by WKC" — marcaj standard CentralSec, poziționat persistent
// în bara de sus a aplicației autentificate (și pe ecranul de login).
export function MadeByBadge({ lang, className }) {
  return (
    <span className={`tiv-badge${className ? ` ${className}` : ""}`}>
      {t(lang, "Made by")} <span className="tiv-mark">WKC</span>
    </span>
  );
}
